import { render } from "./QuestionCreate.vue?vue&type=template&id=a3263522"
import script from "./QuestionCreate.vue?vue&type=script&lang=js"
export * from "./QuestionCreate.vue?vue&type=script&lang=js"

import "./QuestionCreate.vue?vue&type=style&index=0&id=a3263522&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__